import { useState } from "react";
import "./ExpandableList.css";

// ─── ExpandableList ─────────────────────────────────────────────────────────
// Renders `selectedOptions` comma-separated. Two or fewer show in full; more
// than that show only the first two plus a "Показать все/Скрыть" toggle that
// reveals/collapses the rest.
// Props:
//   options         {Array}   Optional full option list, [{ value, label }] or
//                              ["A", "B"], used to resolve labels for values
//                              in `selectedOptions`. When omitted, the values
//                              in `selectedOptions` are shown as-is.
//   selectedOptions {Array}   Values (or plain labels) to display.
//   maxVisible      {number}  How many to show before truncating (default 2).
const ExpandableList = ({ options = [], selectedOptions = [], maxVisible = 2 }) => {
  const [expanded, setExpanded] = useState(false);

  const normalizedOptions = options.map((o) => (typeof o === "string" ? { value: o, label: o } : o));
  const labels = (selectedOptions || []).map((value) => {
    const match = normalizedOptions.find((o) => String(o.value) === String(value));
    return match ? match.label : value;
  });

  if (labels.length === 0) return null;

  const selectedSet = new Set((selectedOptions || []).map(String));
  const allSelected =
    normalizedOptions.length > 0 && normalizedOptions.every((o) => selectedSet.has(String(o.value)));
  if (allSelected) {
    return <span className="expandable-list">Все</span>;
  }

  if (labels.length <= maxVisible) {
    return <span className="expandable-list">{labels.join(", ")}</span>;
  }

  const visibleLabels = expanded ? labels : labels.slice(0, maxVisible);

  return (
    <span className="expandable-list">
      {visibleLabels.map((label, index) => (
        <span key={index}>
          {label + (index !== visibleLabels.length - 1 ? ", " : "") + (index === visibleLabels.length - 1 && !expanded ? "…" : " ")}<br />
        </span>
      ))}
      <button
        type="button"
        className="expandable-list-toggle"
        onClick={(e) => { e.stopPropagation(); setExpanded((prev) => !prev); }}
      >
        {expanded ? "Скрыть" : "Показать все"}
      </button>
    </span>
  );
};

export default ExpandableList;
